import L from "leaflet";
import { pathM } from "@/lib/geo";

export const SIGNS = {
  r101: { label: "Dirección prohibida", code: "R-101", rotatable: false },
  r100: { label: "Circulación prohibida", code: "R-100", rotatable: false },
  r308: { label: "Estacionamiento prohibido", code: "R-308", rotatable: false },
  r302: { label: "Prohibido girar a la izquierda", code: "R-302", rotatable: false },
  r303: { label: "Prohibido girar a la derecha", code: "R-303", rotatable: false },
  r400: { label: "Sentido obligatorio", code: "R-400", rotatable: true },
  valla: { label: "Vallas", code: "Valla", qty: true },
  valla_linea: { label: "Línea de vallas", code: "Vallas", line: true },
  cono: { label: "Conos", code: "TB-6", qty: true },
  panel_desvio: { label: "Panel de desvío", code: "Panel", rotatable: true },
};

const arrow = (rot, fill) => `<g transform="rotate(${rot || 0} 12 12)"><path d="M12 4 L17.5 10.5 H14 V19 H10 V10.5 H6.5 Z" fill="${fill}"/></g>`;

export const signQty = (el) => {
  const m = SIGNS[el.sign_type] || {};
  if (m.line) return Math.max(1, Math.ceil(pathM(el.coords || []) / Math.max(0.5, Number(el.spacing) || 2.5)));
  return m.qty ? Math.max(1, Number(el.qty) || 1) : 1;
};

export const signSvg = (type, rot = 0, size = 24) => {
  if (type === "valla_linea") type = "valla";
  const s = {
    r101: `<circle cx="12" cy="12" r="11" fill="#dc2626" stroke="#fff" stroke-width="1.5"/><rect x="5" y="10" width="14" height="4" fill="#fff"/>`,
    r100: `<circle cx="12" cy="12" r="10" fill="#fff" stroke="#dc2626" stroke-width="3"/>`,
    r308: `<circle cx="12" cy="12" r="10" fill="#1d4ed8" stroke="#dc2626" stroke-width="3"/><line x1="5.5" y1="5.5" x2="18.5" y2="18.5" stroke="#dc2626" stroke-width="3"/>`,
    r302: `<circle cx="12" cy="12" r="10" fill="#fff" stroke="#dc2626" stroke-width="3"/><path d="M14 18.5 V11 H10" stroke="#0f172a" stroke-width="2.4" fill="none"/><path d="M6.5 11 L10.5 7.8 L10.5 14.2 Z" fill="#0f172a"/><line x1="6" y1="6" x2="18" y2="18" stroke="#dc2626" stroke-width="2.4"/>`,
    r303: `<circle cx="12" cy="12" r="10" fill="#fff" stroke="#dc2626" stroke-width="3"/><path d="M10 18.5 V11 H14" stroke="#0f172a" stroke-width="2.4" fill="none"/><path d="M17.5 11 L13.5 7.8 L13.5 14.2 Z" fill="#0f172a"/><line x1="18" y1="6" x2="6" y2="18" stroke="#dc2626" stroke-width="2.4"/>`,
    r400: `<circle cx="12" cy="12" r="11" fill="#1d4ed8" stroke="#fff" stroke-width="1.5"/>${arrow(rot, "#fff")}`,
    valla: `<rect x="1" y="7" width="22" height="10" rx="1" fill="#fff" stroke="#0f172a" stroke-width="1"/><path d="M4 7 L8 7 L4 17 L0.9 17 Z M12 7 L16 7 L12 17 L8 17 Z M20 7 L23 7 L23 10 L19 17 L16 17 Z" fill="#dc2626"/>`,
    cono: `<path d="M12 2 L20 21 H4 Z" fill="#f97316" stroke="#fff" stroke-width="1"/><path d="M9.2 10 H14.8 L15.9 13 H8.1 Z" fill="#fff"/><rect x="3" y="20" width="18" height="2.5" rx="1" fill="#0f172a"/>`,
    panel_desvio: `<rect x="1" y="1" width="22" height="22" rx="2" fill="#facc15" stroke="#0f172a" stroke-width="1.5"/>${arrow(rot, "#0f172a")}`,
  }[type] || "";
  return `<svg width="${size}" height="${size}" viewBox="0 0 24 24">${s}</svg>`;
};

export const signIcon = (el, sel) => {
  const n = signQty(el);
  const q = n > 1 ? `<span style="position:absolute;top:-6px;right:-8px;background:#0f172a;color:#fff;font:700 9px/13px sans-serif;padding:0 3px;border-radius:6px;border:1px solid #fff">${n}</span>` : "";
  return L.divIcon({
    className: "",
    html: `<div style="position:relative;width:26px;height:26px;filter:${sel ? "drop-shadow(0 0 6px #38bdf8)" : "drop-shadow(0 1px 2px #000)"}">${signSvg(el.sign_type, el.rotation, 26)}${q}</div>`,
    iconSize: [26, 26],
    iconAnchor: [13, 13],
  });
};

export const SignMini = ({ type, rot = 0, size = 16 }) => (
  <span className="inline-flex shrink-0" dangerouslySetInnerHTML={{ __html: signSvg(type, rot, size) }} />
);
